import { Image } from '@storyofams/storyblok-toolkit';
import { getLinkProps } from '~/lib';
import { ArrowRight } from '../Icons';
import { Link } from '../Link';

export const RelatedArticleCard = ({ article }) => {
  return (
    <Link href={getLinkProps(article?.slug)}>
      <a className="w-full flex flex-col justify-between">
        <div>
          <div className="w-full aspect-[339/264] overflow-hidden rounded-2xl relative">
            <div className="rounded-full bg-gray-50 border border-gray-100 py-1 px-2.5 text-sm text-gray-700 absolute z-10 top-5 left-5">
              {article?.content?.category}
            </div>
            <Image
              alt={article?.content?.thumbnail?.alt}
              src={article?.content?.thumbnail?.filename}
              fit="cover"
              showPlaceholder={false}
              width="100%"
              height="100%"
              className="rounded-2xl z-0 relative"
            />
          </div>
          <div className="pt-6 text-xl text-gray-800 font-medium leading-[150%]">
            {article?.content?.title}
          </div>
          <div className="text-sm text-gray-500 mt-3">
            {article?.content?.synopsis}
          </div>
        </div>
        <div className="flex items-center mt-8">
          <div>Read more</div>
          <ArrowRight className="w-3 ml-3" />
        </div>
      </a>
    </Link>
  );
};
